const action = {
    async updateMenuAction({ commit }, menus) {
        commit('setMenus', menus);
    },
}

export default action;